import React from 'react'
import styled from "styled-components";
import * as media from "../../../../media";
import Desktop from './Desktop'
import Mobile from './Mobile'
import {compose, withState} from 'recompose'

const BiggerThan1000Check = styled.div`
  ${media.smallerThan(1120)`display:none;`}
`
const LessThan1000Check = styled.div`
  ${media.biggerThan(1121)`display:none;`}
`

const EmptyBox = styled.div`
  height: 150px;
  background-color: #173DB0;
`;

function PriceListRequest(props) {
  return props.currentLanguage === 'en' ? <EmptyBox/> : (
    <div id="question">
      <BiggerThan1000Check>
        <Desktop {...props} />
      </BiggerThan1000Check>
      <LessThan1000Check>
        <Mobile {...props} />
      </LessThan1000Check>
    </div>
  )
}

const enhance = compose(
  withState('name', 'setName', ''),
  withState('email', 'setEmail', ''),
  withState('emailValid', 'setEmailValid', true),
  withState('policyAgreed', 'setPolicyAgreed', false),
  withState('question', 'setQuestion', '')
)

export default enhance(PriceListRequest)


// WEBPACK FOOTER //
// ./src/finwhale/common/price-list-request/inline/index.js